/**************************************************
 * Nombre:       TituloApartados
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {COLORTEXTO, NEGRITA} from "../../../../Constantes";
import {theme} from "../../../../Tema";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const TituloApartados = ({titulo, negrita, postitulo, frase, inicio}) => {
    const sCell = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography
                    sx={{
                        backgroundColor: '#ffffff',
                        borderRadius: 2,
                        px: 2,
                        color: COLORTEXTO,
                        fontWeight: 600,
                        textAlign: 'center',
                        fontSize: 14,
                        pt: 0.7,
                        pb: 0.5
                    }}>{inicio}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center',mt: 3}}>
                <Typography
                    sx={{px: 1, color: COLORTEXTO, textAlign: 'center', fontSize: sCell ? 32 : 48, fontWeight: 700, lineHeight: 1.1}}>
                    {titulo}
                    <span style={{marginLeft: 8, marginRight: 8, color: theme.palette.primary.main}}>
                        {negrita}
                    </span>
                    {postitulo}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center',mt: 1}}>
                <Typography
                    sx={{px: 1, color: COLORTEXTO, textAlign: 'center',fontSize: 18, fontWeight: 600}}>{frase}</Typography>
            </Grid>

        </Grid>
    )

}
export default TituloApartados